export const PLATFORM_ADMIN_ALLOWED_PATHS = [
  '/review',
  '/todos',
  '/unmatched-emails',
  '/messages',
  '/gmail/callback',
];

/** Routes with an id segment under an allowed page — each listed explicitly, so a future nested
 * route is never reachable in Platform Admin View by accident. */
const PLATFORM_ADMIN_ALLOWED_PATH_PREFIXES = [
  // FIN-1435: /messages/<threadId>, the "Open in Harmony" link posted to Slack.
  '/messages/',
];

export function isPlatformAdminAllowedPath(pathname: string): boolean {
  return (
    PLATFORM_ADMIN_ALLOWED_PATHS.includes(pathname) ||
    PLATFORM_ADMIN_ALLOWED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}
